<template>
  <footer>
    <div></div>
    <div>
      <section>
        <h1>Division of Motor Vehicles</h1>
        <p>
          <span class="street">600 New London Avenue</span><span class="city-zip">Cranston, RI 02920-3024</span>Phone: (401) 462-4368
        </p>
      </section>
      <section class="app-no-print">
        <h1>Customer Service</h1>
        <p>
          <a href="http://www.dmv.ri.gov/csa/index.php" target="_blank" rel="noopener noreferrer">
            Customer Service Agreement</a><br/>
          <a href="https://dmv.ri.gov/locations-hours/questions-feedback" target="_blank" rel="noopener noreferrer">
            DMV Feedback Form</a>
        </p>
      </section>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/footer";

footer  {
  @media print {
    margin-top: -3.5rem !important;   // break from WebThemes
    div:nth-child(2) {
      h1 {
        margin-top: 0;
      }
      padding: unset;
    }
  }
}
</style>
